import { usePulseTracking } from "src/utils/pulseHelper.ts";
import { useAppConfig } from "../../context/AppConfigProviderContext.tsx";
import { useOrganisation } from "../../context/DealerDataProviderContext.tsx";
import { Icon } from "./Icon.tsx";
import { ScreenReaderSeparator } from "./ScreenReaderSeparator.tsx";

export const CompanyDetails = () => {
  const { isMobile } = useAppConfig();
  const { companyRegistration, dealerDurationText } = useOrganisation();
  const { trackCompanyRegistration } = usePulseTracking();

  if ((!companyRegistration || !companyRegistration.registrationNumber) && !dealerDurationText) {
    return null;
  }

  return (
    <>
      <div className="flex flex-wrap items-center gap-8">
        {companyRegistration?.registrationNumber && (
          <>
            {/* WebKit's aggressive phone number detection changes text into a link so this is an attempt to prevent it */}
            <span className="s-text! no-underline!">{companyRegistration.registrationNumber}</span>
            <a
              className="flex items-center gap-4"
              target="_blank"
              rel="noopener noreferrer"
              href={companyRegistration.registrationNumberLinkUrl}
              onClick={() => trackCompanyRegistration(companyRegistration)}
            >
              {companyRegistration.registrationNumberShortLinkTitle}
              <ScreenReaderSeparator />
              <Icon name="LinkExternal" />
            </a>
          </>
        )}
        {!isMobile && dealerDurationText && (
          <>
            {companyRegistration?.registrationNumber && <span className="px-4">·</span>}
            <span>{dealerDurationText}</span>
          </>
        )}
      </div>
      {isMobile && dealerDurationText && (
        <span className={companyRegistration?.registrationNumber ? "pt-8" : ""}>{dealerDurationText}</span>
      )}
    </>
  );
};
